export const RangeFilterTypeId = 'RangeFilter'

type rangeFilterTypeIdType = typeof RangeFilterTypeId

export interface RangeFilterInterface {
  typeId: rangeFilterTypeIdType
  from?: string
  to?: string
}
